import { FC, memo, useState } from 'react'

import { clearUsersStorage } from '@sportworld/js-sdk/src/actions/user'
import {
  clearRootDomainEnv,
  getRootDomainEnv,
  setRootDomainEnv,
  b1RootDomain,
} from '@sportworld/js-sdk/src/envs/envs'

import { Button } from '@/components/Button/Button'
import { Select } from '@/components/Select/select'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { reloadApp } from '@/platform/platform'
import { SelectOptionType } from '@/types/componentsPropsTypes'

import { ButtonWrapper, ContentContainer } from './styles'

const environments: SelectOptionType[] = [
  { label: 'auto', id: 'auto' },
  { label: 'dev', id: 'dev' },
  { label: 'test', id: 'test' },
  { label: 'prod', id: 'prod' },
]

const EnvironmentSelectionRaw: FC = () => {
  const rootDomainEnv = getRootDomainEnv()

  const { t } = useCommonTranslation()
  const [selectedEnvironment, setSelectedEnvironment] =
    useState<string>(rootDomainEnv)

  const handleAppReload = () => {
    clearUsersStorage()
    reloadApp()
  }

  const onSelectedHandler = (selectedEnv: string) => {
    if (rootDomainEnv === selectedEnv) {
      return
    }

    setSelectedEnvironment(selectedEnv)
    setRootDomainEnv(selectedEnv)
    handleAppReload()
  }

  return (
    <ContentContainer>
      <div>
        <p>
          <span>Verson:</span> {import.meta.env.REACT_APP_VERSION}
        </p>
        <p>
          <span>Domain:</span> {b1RootDomain}
        </p>
        <p>
          <span>Selected Environment:</span> {selectedEnvironment}
        </p>
      </div>
      <ButtonWrapper>
        <Select
          selectOptions={{
            title: 'Change Environment',
            description: 'Warning: Environment change will quit the app',
            selectOptionList: environments,
            selectedOptionId: selectedEnvironment,
            onSelect: onSelectedHandler,
          }}
          actionComponent={
            <>
              <Button text={t('change')} onClick={() => {}} smallButton />
              <Button
                text="Reset"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  clearRootDomainEnv()
                  handleAppReload()
                }}
                smallButton
              />
            </>
          }
        />
      </ButtonWrapper>
    </ContentContainer>
  )
}

export const EnvironmentSelection = memo(EnvironmentSelectionRaw)
